import { Card } from '../common/Card';
import { Spinner } from '../common/Spinner';
import { Mail24Regular, Person24Regular } from '@fluentui/react-icons';

interface EmailSummaryProps {
  subject: string | undefined;
  sender: { name: string; email: string } | null;
  bodyPreview: string | null;
  isLoading?: boolean;
}

export function EmailSummary({ subject, sender, bodyPreview, isLoading }: EmailSummaryProps) {
  if (isLoading) {
    return (
      <Card>
        <div style={{ display: 'flex', justifyContent: 'center', padding: 'var(--spacing-md)' }}>
          <Spinner size="small" label="Loading email..." />
        </div>
      </Card>
    );
  }

  if (!subject && !sender) {
    return (
      <Card>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'var(--spacing-sm)',
            padding: 'var(--spacing-md)',
            color: 'var(--color-gray-500)',
          }}
        >
          <Mail24Regular style={{ fontSize: '32px' }} />
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 500 }}>No email selected</div>
            <div style={{ fontSize: '12px' }}>Select an email to generate a draft reply</div>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-sm)' }}>
        {/* Subject */}
        <div
          style={{
            fontWeight: 600,
            fontSize: '16px',
            color: 'var(--color-gray-900)',
          }}
        >
          {subject || '(No subject)'}
        </div>

        {/* Sender */}
        {sender && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-xs)',
              color: 'var(--color-gray-600)',
              fontSize: '13px',
            }}
          >
            <Person24Regular style={{ fontSize: '16px' }} />
            <span>
              {sender.name} &lt;{sender.email}&gt;
            </span>
          </div>
        )}

        {/* Body Preview */}
        {bodyPreview && (
          <div
            style={{
              fontSize: '13px',
              color: 'var(--color-gray-500)',
              lineHeight: 1.5,
              paddingTop: 'var(--spacing-xs)',
              borderTop: '1px solid var(--color-gray-100)',
            }}
          >
            {bodyPreview}
          </div>
        )}
      </div>
    </Card>
  );
}
